import {isNull} from "util";

export class MuseOn {

    protected removeNull(obj: object) {
        Object.entries(obj).forEach(entry => {
            if (isNull(entry[1]))
                delete obj[entry[0]];
            if (typeof entry[1] === 'string' && entry[1] === '')
                delete obj[entry[0]];
        });

        return obj;
    }
}